import React, { useState } from 'react';
// ANIMATION
import styled from 'styled-components';
import { motion } from 'framer-motion';
import logo from "../img/logo.svg";

// REDUX AND ROUTES
import {fetchSearch} from '../actions/gameAction';
import { useDispatch } from 'react-redux';

import { fadeIn } from '../animations';

const Nav = () =>{

    // SEARCH FUNCTIONAlITY
    const dispatch = useDispatch();
    const [textInput, setTextInput] = useState("");

    const inputHandler = (e) =>{
        setTextInput(e.target.value);
    }

    const submitSearch = (e) => {
        e.preventDefault();
        dispatch(fetchSearch(textInput));
        setTextInput("");
    }

    // CLEAR SEARCH
    const clearSearched = () =>{
        dispatch({
            type: "CLEAR_SEARCHED"
        });
    }

    return(
        <StyledNav variants={fadeIn} initial="hidden" animate="show">

            <Logo onClick={clearSearched}>
                <img src={logo} alt="logo"/>
                <h1>Inferno</h1>
            </Logo>
            <form className="search">
                <input value={textInput} onChange={inputHandler} type="text" />
                <button onClick={submitSearch} type="submit">Search</button>
            </form>
        </StyledNav>
    );
};

const StyledNav = styled(motion.div)`
  padding: 3rem 5rem;
  text-align: center;
  input {
    width: 30%;
    font-size: 1.5rem;
    padding: 0.5rem;
    border: none;
    margin-top: 1rem;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.2);
  }
  button {
    font-size: 1.5rem;
    border: none;
    padding: 0.5rem 2rem;
    cursor: pointer;
    background: #ff7676;
    color: white;
  }
`;

const Logo = styled(motion.div)`
  display: flex;
  justify-content: center;
  padding: 1rem;
  cursor: pointer;
  img {
    height: 2rem;
    width: 2rem;
  }
`;


export default Nav;